module.exports = __webpack_public_path__ + "assets/RetinaNarr-BlackItalic.4426d69c48813a477c27b03bb7ddcb8c.woff";